var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress',{style:({opacity: (_vm.loading) ? 1 : 0})})
}
var staticRenderFns = []

export { render, staticRenderFns }